// extracted by mini-css-extract-plugin
export default {"container":"i3-z","heading":"j3-z","links":"k3-z","copy":"l3-z","subCopy":"m3-z","linksLeft":"n3-z","linksCenter":"o3-z","linksRight":"p3-z","link":"q3-z","onlyLink":"r3-z"};